import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import 'bootstrap-v5/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.css';
import TagManager from 'react-gtm-module';

import App from './components/app/app';
import ErrorBoundary from './airbrake';
import store, { history } from './store';
import {unregister} from './registerServiceWorker';

import './assets/style/glyphicons.css';
import './assets/style/index.css';
import './assets/style/bootstrap-theme.css';
import './assets/style/user-frontend/index.css';
import './assets/style/user-frontend/bootstrap-theme.css';
import './assets/style/admin-search-filters.css';
import withTracker from './withTracker';
import {GOOGLE_TAG_MANAGER_API_KEY} from './data/googleTagManager';
import {clear, hasSessionGroupClaims, storedImpersonationScope} from './utils/tokenUtils';

const tagManagerArgs = {
  gtmId: GOOGLE_TAG_MANAGER_API_KEY
};

TagManager.initialize(tagManagerArgs);

const TrackedApp = withTracker(App);

const app = (
  <ErrorBoundary>
    <Provider store={store}>
      <HistoryRouter history={history}>
        <TrackedApp />
      </HistoryRouter>
    </Provider>
  </ErrorBoundary>
);

unregister();

// TODO: remove this guard once every session predating the user_group /
// original_user_group JWT claims has expired (3 hours after release).
const loginPathForSession = () => {
  const impersonationScope = storedImpersonationScope();

  if (impersonationScope) {
    return impersonationScope === 'team' ? '/team/login' : '/admin/login';
  }

  const { pathname } = window.location;

  if (pathname.startsWith('/admin')) return '/admin/login';
  if (pathname.startsWith('/team')) return '/team/login';
  return '/';
};

if (hasSessionGroupClaims()) {
  const root = createRoot(document.getElementById('root'));
  root.render(app);
} else {
  const loginPath = loginPathForSession();

  clear();
  window.location.replace(loginPath);
}
